import { render, staticRenderFns } from "./DictSelect.vue?vue&type=template&id=ac7ea2b2&scoped=true"
import script from "./DictSelect.vue?vue&type=script&lang=js"
export * from "./DictSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../hotel-wc-product/hotel-wc/sources/client/hotel-wc-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac7ea2b2",
  null
  
)

export default component.exports